import { useNewRoleContext } from 'lib/context/Role/NewRoleContext/NewRoleContext';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

import Wizard from '../../Wizard/Wizard';
import FooterButtons from '../components/FooterButtons';
import AssignRole from '../components/NewRole/AssignRole/AssignRole';
import ManagePermissions from '../components/NewRole/ManagePermissions/ManagePermissions';
import RoleDetails from '../components/NewRole/RoleDetails/RoleDetails';

const NewRoleModal = ({ forAdmin }) => {
  const { showNewRoleModal, breadCrumbs, setBreadCrumbs, handleClose } = useNewRoleContext();

  const actionViews = {
    role_details: {
      component: <RoleDetails forAdmin={forAdmin} />,
      footer: (
        <FooterButtons
          buttonText="Set Permissions"
          nextTo="manage_permissions"
          showNavigationButtons
          firstStep={true}
          setBreadCrumbs={setBreadCrumbs}
        />
      )
    },
    manage_permissions: {
      component: <ManagePermissions forAdmin={forAdmin} />,
      footer: (
        <FooterButtons
          buttonText="Assign Role"
          backTo="role_details"
          nextTo="assign_role"
          showNavigationButtons
          setBreadCrumbs={setBreadCrumbs}
        />
      )
    },
    assign_role: {
      component: <AssignRole forAdmin={forAdmin} />,
      footer: (
        <FooterButtons
          buttonText="Save Role"
          backTo="manage_permissions"
          isLastStep
          setBreadCrumbs={setBreadCrumbs}
        />
      )
    }
  };

  const getCurrentView = () => {
    const currentView = breadCrumbs?.find((row) => row.active).view;
    return actionViews[currentView].component;
  };

  const getCurrentFooter = () => {
    const currentView = breadCrumbs?.find((row) => row.active).view;
    return actionViews[currentView].footer;
  };

  return (
    showNewRoleModal && (
      <Wizard
        isOpen={showNewRoleModal}
        handleClose={handleClose}
        title="Create New Role"
        breadcrumbs={breadCrumbs}
        setBreadCrumbs={setBreadCrumbs}
        footerButtons={getCurrentFooter()}>
        {getCurrentView()}
      </Wizard>
    )
  );
};

export default withErrorBoundary(NewRoleModal);
